export default __webpack_public_path__ + "static/media/csv.2f94bca2.svg";